import axios from 'axios';
import { API_URL } from '../Constants/URL';

const API_BASE_URL = API_URL || 'http://localhost:5000';

export const sendEmail = async (emailData: any) => {
  const response = await axios.post(`${API_BASE_URL}api/email/send-email`, emailData);
  return response.data;
};